import type { ICheckedTreatment } from '@common/interfaces';

export function getProgrammeList(checkedTreatments: ICheckedTreatment[] = []) {
    return checkedTreatments.map((treatment) => treatment.treatmentName).join(', ');
}
